import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import { fetchingFilters } from './actions';

export const reducer = reducerWithInitialState(initialState)
    .case(fetchingFilters.started, state => ({
        ...state,
    }))
    .case(fetchingFilters.done, (state, { result: { categoryFilter, empty } }) => ({
        ...state,
        categoryFilter,
        empty,
    }))
    .case(fetchingFilters.failed, (state, { error }) => ({
        ...state,
        error,
    }));

export default reducer;
